import NewTag from "@/assets/images/NewTag";
import { COLORS } from "@/shared/constants/colors";
import { faCaretDown } from "@fortawesome/pro-light-svg-icons";
import {
  faCaretDown as faCaretDownSolid,
  faCaretUp,
} from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@graphy/ui";
import Link from "next/link";
import { useRouter } from "next/router";
import { useRef, useState } from "react";

interface SubMenuProps {
  label: string;
  handleToggle: () => void;
  isOpen: boolean;
  onClose: () => void;
  closeMwebNavbar: () => void;
  menuItems: {
    name: string;
    link?: string;
    isNew?: boolean;
  }[];
}

export const NavbarMenuMweb = ({
  label,
  menuItems,
  handleToggle,
  isOpen,
  onClose,
  closeMwebNavbar,
}: SubMenuProps) => {
  const router = useRouter();
  const ref = useRef(null);
  const [showHoverIcon, setShowHoverIcon] = useState(false);

  const onClickSubLink = () => {
    onClose();
    closeMwebNavbar();
  };

  return (
    <div className="w-full">
      <div
        className={`flex h-10 w-full cursor-pointer items-center justify-center gap-0.5 text-caption font-normal hover:text-sapphire02 ${
          isOpen ? "text-purple-4" : "text-grey-3"
        }`}
        onClick={handleToggle}
        onMouseOver={() => {
          setShowHoverIcon(true);
        }}
        onMouseLeave={() => {
          setShowHoverIcon(false);
        }}
      >
        <button>{label}</button>
        {showHoverIcon && !isOpen ? (
          <Icon
            icon={faCaretDownSolid}
            className="ml-1"
            color={COLORS.SAPPHIRE_02}
          />
        ) : (
          <Icon
            icon={isOpen ? faCaretUp : faCaretDown}
            className="ml-1"
            color={isOpen ? COLORS.PURPLE_04 : COLORS.GREY_03}
          />
        )}
      </div>

      <ul
        className={`md:hidden ${
          isOpen
            ? "flex w-full flex-col items-center justify-center text-center"
            : "hidden"
        }`}
      >
        {menuItems.map((item, index) => {
          return (
            <>
              {item?.link && (
                <li
                  key={item.name + item.link + index + "mweb"}
                  className={`flex h-8 w-full cursor-default items-center justify-center text-body font-medium text-grey-4`}
                  onClick={() => {
                    if(item?.link){
                    router.push(item.link);
                    onClickSubLink();
                    }
                  }}
                >
                  <Link href={item.link} prefetch={false}>
                    {" "}
                    {item.name}
                    {item.isNew && (
                      <span className="ml-1 inline-flex">
                        <NewTag
                          width={28}
                          height={14}
                          className="inline-block"
                        />
                      </span>
                    )}
                  </Link>
                </li>
              )}
            </>
          );
        })}
      </ul>
    </div>
  );
};
